import Vue from 'vue'

import currencyMixin from './currency'
import dataMixin from './data'
import datetimeMixin from './datetime'
import gotoMixin from './goto'
import percentMixin from './percent'
import powerMixin from './power'
import tableMixin from './table'

Vue.mixin(currencyMixin)
Vue.mixin(dataMixin)
Vue.mixin(datetimeMixin)
Vue.mixin(gotoMixin)
Vue.mixin(percentMixin)
Vue.mixin(powerMixin)
Vue.mixin(tableMixin)
